import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../Layout/Grid/Cell/Default/EnumCell";
import { odcTypeAsString } from "../OdcType";

export const odcTypeEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={odcTypeAsString} />
);

export const odcTypeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { Type: "ODC" },
      { Type: "Rail" },
      { Type: "Port" },
      { Type: "Cross Dock" },
      { Type: "EPC" },
    ]}
    searchBox={() => null}
    {...props}
  />
);
